module.exports = __webpack_public_path__ + "img/unlock-blue-lock-gif.7ee13ffe.gif";